import { render, staticRenderFns } from "./cattleTable.vue?vue&type=template&id=df48c0be&scoped=true"
import script from "./cattleTable.vue?vue&type=script&lang=js"
export * from "./cattleTable.vue?vue&type=script&lang=js"
import style0 from "./cattleTable.vue?vue&type=style&index=0&id=df48c0be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df48c0be",
  null
  
)

export default component.exports